import React, { useEffect, useState, useRef } from 'react';
export const Services = () => {
  const [activeTab, setActiveTab] = useState('corporate-law');
  const sectionRef = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('opacity-100');
        entry.target.classList.remove('opacity-0', 'translate-y-10');
      }
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  const corporateLawServices = [{
    title: 'Mergers & Acquisitions',
    description: 'Strategic guidance through complex M&A transactions, ensuring legal compliance and optimal business outcomes.'
  }, {
    title: 'Corporate Governance',
    description: 'Establish robust governance frameworks that balance regulatory compliance with operational efficiency.'
  }, {
    title: 'Contract Negotiations',
    description: 'Expert negotiation and drafting of contracts that protect your interests while facilitating business growth.'
  }, {
    title: 'Regulatory Compliance',
    description: 'Navigate complex regulatory landscapes with tailored compliance strategies for your industry.'
  }, {
    title: 'Intellectual Property',
    description: 'Comprehensive protection of your intellectual assets, from trademarks to patents and trade secrets.'
  }, {
    title: 'Dispute Resolution',
    description: 'Strategic approach to resolving disputes, prioritizing business continuity and minimizing disruption.'
  }];
  const businessStrategyServices = [{
    title: 'Market Entry Strategy',
    description: 'Data-driven strategies for entering new markets, identifying opportunities and mitigating risks.'
  }, {
    title: 'Organizational Restructuring',
    description: 'Optimize your organizational structure for efficiency, growth, and market responsiveness.'
  }, {
    title: 'Growth & Expansion Planning',
    description: 'Comprehensive roadmaps for sustainable business growth and market expansion.'
  }, {
    title: 'Competitive Analysis',
    description: 'In-depth analysis of competitive landscapes to identify strategic advantages and opportunities.'
  }, {
    title: 'Financial Strategy',
    description: 'Strategic financial planning to optimize capital allocation and maximize returns.'
  }, {
    title: 'Digital Transformation',
    description: 'Navigate digital disruption with strategies that leverage technology for competitive advantage.'
  }];
  return <section id="services" className="py-20 bg-gray-50" data-id="element-240">
      <div className="container mx-auto px-4" data-id="element-241">
        <div ref={sectionRef} className="text-center max-w-3xl mx-auto mb-16 transition-all duration-1000 opacity-0 translate-y-10" data-id="element-242">
          <h2 className="text-primary font-serif text-3xl md:text-4xl font-bold mb-6" data-id="element-243">
            Our Expertise
          </h2>
          <div className="w-20 h-1 bg-gold mx-auto mb-8" data-id="element-244"></div>
          <p className="text-gray-700" data-id="element-245">
            Niqqanno Consulting offers a unique dual expertise in Corporate Law
            and Business Strategy, providing comprehensive solutions that
            address both legal requirements and strategic business objectives.
          </p>
        </div>
        {/* Tabs */}
        <div className="flex flex-col md:flex-row justify-center mb-12 space-y-4 md:space-y-0" data-id="element-246">
          <button className={`px-8 py-4 font-medium transition-all duration-300 ${activeTab === 'corporate-law' ? 'bg-primary text-white' : 'bg-white text-primary hover:bg-gray-100'} md:rounded-l-md`} onClick={() => setActiveTab('corporate-law')} data-id="element-247">
            Corporate Law
          </button>
          <button className={`px-8 py-4 font-medium transition-all duration-300 ${activeTab === 'business-strategy' ? 'bg-primary text-white' : 'bg-white text-primary hover:bg-gray-100'} md:rounded-r-md`} onClick={() => setActiveTab('business-strategy')} data-id="element-248">
            Business Strategy
          </button>
        </div>
        {/* Tab Content */}
        <div className="bg-white p-8 md:p-12 shadow-lg rounded-md" data-id="element-249">
          {activeTab === 'corporate-law' && <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-250">
              {corporateLawServices.map((service, index) => <div key={index} className="p-6 border border-gray-100 hover:border-gold transition-all duration-300 hover:shadow-md" data-id="element-251">
                  <h3 className="text-primary font-bold text-xl mb-4" data-id="element-252">
                    {service.title}
                  </h3>
                  <p className="text-gray-700" data-id="element-253">{service.description}</p>
                </div>)}
            </div>}
          {activeTab === 'business-strategy' && <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-254">
              {businessStrategyServices.map((service, index) => <div key={index} className="p-6 border border-gray-100 hover:border-gold transition-all duration-300 hover:shadow-md" data-id="element-255">
                  <h3 className="text-primary font-bold text-xl mb-4" data-id="element-256">
                    {service.title}
                  </h3>
                  <p className="text-gray-700" data-id="element-257">{service.description}</p>
                </div>)}
            </div>}
        </div>
      </div>
    </section>;
};